import React, { useState, useEffect } from 'react';
import menuData from '../data/menu.json';
import './OurMenu.css';

interface MenuItem {
  name: string;
  description: string;
  price: number;

}

interface MenuCategory {
  category: string;
  items: MenuItem[];
}

const OurMenu: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [activeCategory, setActiveCategory] = useState<string>('');
  const [displayItems, setDisplayItems] = useState<MenuItem[]>([]);

  const allCategories: MenuCategory[] = menuData.menu;
  const categoryNames: string[] = allCategories.map((cat) => cat.category);

  useEffect(() => {
    if (categoryNames.length > 0 && !activeCategory) {
      setActiveCategory(categoryNames[0]); // Set the first category as active by default
    }
  }, [categoryNames, activeCategory]);

  useEffect(() => {
    const currentCategoryData = allCategories.find(
      (cat) => cat.category === activeCategory
    );

    if (currentCategoryData) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filteredItems = currentCategoryData.items.filter(
        (item) =>
          item.name.toLowerCase().includes(lowercasedSearchTerm) ||
          item.description.toLowerCase().includes(lowercasedSearchTerm)
      );
      setDisplayItems(filteredItems);
    } else {
      setDisplayItems([]);
    }
  }, [searchTerm, activeCategory, allCategories]);

  return (
    <section id="menu">
      <h2>Our Menu</h2>
      <div className="menu-category-tabs">
        {categoryNames.map((catName) => (
          <button
            key={catName}
            className={activeCategory === catName ? 'active' : ''}
            onClick={() => {
              setActiveCategory(catName);
              setSearchTerm(''); // Clear search when changing tabs
            }}
          >
            {catName}
          </button>
        ))}
      </div>
      <div className="menu-search-bar">
        <input
          type="text"
          placeholder={`Search in ${activeCategory}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="menu-content">
        {displayItems.length > 0 ? (
          <ul className="menu-items-list">
            {displayItems.map((item) => (
              <li key={item.name} className="menu-item">

                <h4>{item.name}</h4>
                <p>{item.description}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No items found in {activeCategory} matching your search.</p>
        )}
      </div>
    </section>
  );
};

export default OurMenu;
